import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../section/user/service/user.service';
import { SharedService } from '../../../component/shared/shared.service';
import { UserDetail } from '../model/user-detail';
import { Patient } from '../../../section/patient/model/patient';
import { AppointmentService } from '../../../section/appointment/service/appointment.service';
import { Appointment, Schedule } from '../../../section/appointment/model/appointment';
import { Clinic } from '../../master/model/clinic';
import { ClinicMasterService } from '../../master/services/clinic-master.service';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  userService : UserService;
  usrData:UserDetail = null;
  appointments : Appointment[];
  patientsData: Patient[];
  patientData: Patient;
  clinics : Clinic[];
  userClinic= null;
  appDate: any;;
  dtOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  constructor(private _sharedService: SharedService,private _UserService: UserService, private _appService : AppointmentService, private _clinicService : ClinicMasterService  ) {
    _sharedService.bookingEmitted$.subscribe(
      text => {
        
          let date = this.appDate.date.year + '/' + this.appDate.date.month + '/'+ this.appDate.date.day;
          this.getAppointmentForDay(date);
        
      });
    this.userService = _UserService;
    let dt = new Date();
    this.appDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
   }

  ngOnInit() {
    
    this.getUserDetail();
    this.getClinic();
  }
  getUserDetail() {
    this.userService.getUserProfile().subscribe(data=>{
       if(data.length>0) {
        this.usrData = data[0];
      
      }
      
    },error => {
       
    })
  }
  getClinic() : void {
    
    this._clinicService.getClinic().subscribe(data=>{
     
      this.clinics  = data;
      this.userClinic = this.clinics[0].ClinicId;
      let dt = new Date();
      let date = this.appDate.date.year + '/' + this.appDate.date.month + '/'+ this.appDate.date.day;
      this.getAppointmentForDay(date);
    },
    error=>{
        
    });
  }
  onDateChanged(event: IMyDateModel) {
    if(event.date != null && event.date.year != 0) {
      let date = event.date.year + '/' + event.date.month + '/'+ event.date.day;
      this.getAppointmentForDay(date);
    } else {
       return;
    }
  }
  getAppointmentForDay(date:string) : void {
  
     this._appService.getDoctorAppointmentForDateRange(0, this.userClinic, date, date).subscribe(data=>{
       this.appointments = data;
       this.patientsData = [];
       var ptData : any [] = [];
       for(let i=0; i<this.appointments.length; i++) {
          if(ptData.indexOf(this.appointments[i].AppointmentPatientName)==-1) {
            this.patientData = new Patient(this.appointments[i].AppointmentPatientId,this.appointments[i].AppointmentPatientName.split(' ')[0],this.appointments[i].AppointmentPatientName.split(' ')[1],'','',null,'','','','','',this.appointments[i].AppointmentPatientContactNo,null,'',null,this.appointments[i].AppointmentPatientMail,'','','',null,null,'');
            ptData.push(this.appointments[i].AppointmentPatientName);
            this.patientsData.push(this.patientData);

          }
       }
        
     },error=>{

     });
  }
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  bookAppointment() {
    if(this.usrData.UserRoleId==2 || this.usrData.UserRoleId==1) {
      this._sharedService.overlay( {'module' :'USER','type' : 'PROFILE','isShow' : true,'data' : this.usrData, 'secondData' : null});
    } else {
      this._sharedService.overlay( {'module' :'USER','type' : 'PROFILE','isShow' : true,'data' : null, 'secondData' : null});
    }
       
  }
  
 

}



// WEBPACK FOOTER //
// ./src/app/section/user/user-profile/user-profile.component.ts